import dayjs from 'dayjs';
import { PredictedDemandModel } from '../../../../app/services/api/podClient';
import { OrderFormItem, OrderFormCategory } from '../../../../app/services/api/orderManagementClient';
import { getInventorySku } from '../../../../utils';

/** Demo Mode only - deterministic, fake predicted-demand figures for the Order Form/Order
 * Planning "predictive forecasting" columns. No real POD (Predictive Ordering & Demand) API
 * call is made in Demo Mode (see loadPredictedDemands/loadPodStoreConfiguration in
 * OrderForm/index.tsx) - these numbers are seeded from the item number and date so the same
 * item/date combination always shows the same figures.
 * lazy: seeded pseudo-random within plausible ranges, not a real demand forecast - upgrade to
 * the real podClient call if this needs to reflect actual predicted demand. */
const seededRandom = (seed: number) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) || 1;
};

export const getMockPredictedDemands = (
  categories: OrderFormCategory[],
  deliveryDates: string[],
): PredictedDemandModel[] => {
  const items: OrderFormItem[] = categories.flatMap((category) => category.items);

  return items.map((item) => {
    const itemNumber = getInventorySku(item);
    const itemSeed = hashString(itemNumber);

    return {
      itemNumber,
      predictionInfo: null,
      predictedDemandItems: deliveryDates.map((deliveryDate, dateIndex) => {
        const seed = itemSeed * 7 + dateIndex * 13;
        const predictedDemandQuantity = Math.max(1, Math.round(seededRandom(seed) * 18) + 2);
        const safetyStock = Math.max(0, Math.round(predictedDemandQuantity * 0.2));

        return {
          quantity: predictedDemandQuantity,
          date: (deliveryDate.includes('/') ? dayjs(deliveryDate, 'MM/DD/YYYY') : dayjs(deliveryDate, 'DD-MM-YYYY')).toDate(),
          hasPrediction: true,
          predictedDemandQuantity,
          safetyStock,
          minStockOnHandQty: safetyStock,
        };
      }),
    };
  });
};
